import React from 'react';
import PropTypes from 'prop-types';
import { PiCheck, PiSortAscending } from 'react-icons/pi';
import BottomSheet from '../BottomSheet';
import './styles.css';

export const SORT_OPTIONS = [
  { value: 'data-desc', label: 'Mais recentes primeiro' },
  { value: 'data-asc', label: 'Mais antigas primeiro' },
  { value: 'valor-desc', label: 'Maior valor' },
  { value: 'valor-asc', label: 'Menor valor' },
];

const SortSheet = ({ value, onSelect, onClose }) => (
  <BottomSheet
    title="Ordenar movimentações"
    subtitle="Escolha como a lista deve ser exibida."
    onClose={onClose}
    size="sm"
  >
    <div className="sort-sheet" role="radiogroup" aria-label="Opções de ordenação">
      {SORT_OPTIONS.map((option) => {
        const selected = value === option.value;
        return (
          <button
            type="button"
            role="radio"
            aria-checked={selected}
            className={`sort-sheet__option ${selected ? 'is-selected' : ''}`}
            key={option.value}
            onClick={() => onSelect(option.value)}
          >
            <span className="sort-sheet__option-icon" aria-hidden="true"><PiSortAscending size={20} /></span>
            <span>{option.label}</span>
            {selected && <PiCheck className="sort-sheet__check" size={20} aria-hidden="true" />}
          </button>
        );
      })}
    </div>
  </BottomSheet>
);

SortSheet.propTypes = {
  value: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SortSheet;
